<template>
	<div class="schedamacchina">
		<b-modal
			no-close-on-backdrop
			title="Machine Customization"
			class="modal-success"
			v-model="editNameDlg"
			ok-variant="success"
			:ok-only="false"
			ok-title="Save"
			size="lg"
            @ok="saveName"
		>
			<b-container fluid>
				<b-row>
					<b-col>
                        <span>
                            Edit here to customize the name and the location of the machine
                        </span><br><br>
                        <b-form-group label="Machine Name" label-for="mName">
                            <b-form-input id="mName" v-model="mName"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Machine Location" label-for="mLocation">
                            <b-form-input id="mLocation" v-model="mLocation"></b-form-input>
                        </b-form-group>
                    </b-col>
				</b-row>
			</b-container>
		</b-modal>
		<b-card>
			<b-row>
				<b-col cols="5" class="descr">
					<div class="nome" :title="m.label_info || 'null'">
						{{ m.nome }} - {{ m.codice }} Delivered&nbsp;date:{{ m.delivered }}
					</div>
					<div class="macchina">{{ m.macchina }}</div>
					<!-- <div class="mdescr">{{ m.descr }}</div> -->
					<div class="location">{{ m.location }}</div>
					<b-button
						@click="showMachine(m)"
						type="submit"
						variant="primary"
						v-if="info"
					>
						{{buttontext || "MORE INFO"}}
					</b-button>
				</b-col>
				<b-col cols="7">
                    <img v-if="m.promo" width="50px" src="/images/star.svg" data-html="true" style="white-space: pre-line;" :title="tip(m.promo)" class="promo">
					<img width="100%" :src="m.image" /><br />
					<div
						@click="editName()"
						class="editname"
						title="click here to customize the name and the location of the machine"
					>
						{{m.nomepers}}<br><div class="location">{{ m.locationpers }}</div>
					</div>
				</b-col>
			</b-row>
		</b-card>
	</div>
</template>

<script>
import { API } from "@/api.js";

export default {
	data: function () {
		return {
			editNameDlg: false,
            mName: '',
            mLocation: '',
		};
	},
	name: "SchedaMacchina",
	props: {
		m: Object,
		info: Boolean,
        justEmit: Boolean,
        route: String,
        buttontext: String,
	},
	methods: {
        tip(titles){
            return titles.join('\n')
        },
        saveName(){
            console.log("saveName2",this.mName,this.mLocation)
            API.setUnit(this.m.codice,this.mName,this.mLocation)
            this.m.nomepers = this.mName
            this.m.locationpers = this.mLocation
        },
		editName() {
            this.mName = this.m.nomepers
            this.mLocation = this.m.locationpers
            this.editNameDlg = true
        },
		showMachine(m) {
            console.log("showing machine", m);
            this.$store.commit("machine", m);
            this.$emit('show')
            if(!this.justEmit){
                this.$router.push(this.route || "scinfomacchina");
            }
		},
	},
};
</script>

<style scoped>
img.promo {
    position: absolute;
    right: 10px;
    bottom: 10px;
}
div.editname {
	cursor: pointer;
	text-align: left;
}
div.schedamacchina {
	/* height: 100%; */
}
div.schedamacchina div.card-body {
	min-height: 180px;
}
div.card {
	margin: 10px;
	height: 90%;
}
div.descr {
	text-align: left;
}
div.nome {
	font-weight: 700;
}
div.macchina {
	font-weight: 300;
}
div.mdescr {
	font-size: x-small;
}
div.location {
	font-style: oblique;
}
div.machines button {
	right: 0px;
	background-color: #9a240d !important;
	border-color: #9a240d !important;
	position: relative;
	top: 5px;
}
div.machines button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.machines button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.schedamacchina button {
	right: 0px;
	background-color: #9a240d !important;
	border-color: #9a240d !important;
	position: relative;
	top: 5px;
}
div.schedamacchina button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.schedamacchina button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
</style>
